var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4878 1.35992C29.4201 3.1955 29.4467 6.19957 27.5497 8.07003C25.6527 9.94049 22.5441 9.96665 20.6117 8.13107C18.6793 6.29549 18.6528 3.29142 20.5498 1.42096C22.4468 -0.449494 25.5554 -0.475654 27.4878 1.35992Z",
    fill: "url(#paint0_linear_12733_53893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.764 18.0372L38.9617 15.8746L32.09 9.34766L29.8923 11.5102C26.7395 14.6146 21.5394 14.6582 18.3291 11.6105L16.0916 9.48282L9.34375 16.1319L11.5812 18.2596C18.5678 24.8999 29.9012 24.7996 36.764 18.0416",
    fill: "url(#paint1_linear_12733_53893)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7716 41.2328C42.2246 42.131 39.4123 40.8578 38.4837 38.3944C37.5551 35.931 38.8684 33.2059 41.4154 32.3121C43.9624 31.4183 46.7747 32.6871 47.7033 35.1505C48.6319 37.614 47.3186 40.339 44.7716 41.2328Z",
    fill: "url(#paint2_linear_12733_53893)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2182 42.1526L26.2927 45.0041L35.3444 41.8169L34.2698 38.9654C32.731 34.8757 34.9331 30.3151 39.156 28.8283L42.101 27.7906L38.8067 19.0356L35.8617 20.0733C26.6597 23.3128 21.8708 33.2494 25.2182 42.157",
    fill: "url(#paint3_linear_12733_53893)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22789 41.2326C5.7749 42.1307 8.58724 40.8576 9.51584 38.3942C10.4444 35.9308 9.13113 33.2057 6.58411 32.3119C4.0371 31.4138 1.22476 32.6869 0.296164 35.1503C-0.632436 37.6137 0.680869 40.3388 3.22789 41.2326Z",
    fill: "url(#paint4_linear_12733_53893)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7813 42.1526L21.7067 45.0041L12.6551 41.8169L13.7296 38.9654C15.2685 34.8757 13.0663 30.3151 8.84343 28.8283L5.89844 27.7906L9.19276 19.0356L12.1377 20.0733C21.3397 23.3128 26.1287 33.2494 22.7813 42.157",
    fill: "url(#paint5_linear_12733_53893)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12733_53893",
    x1: 19.1436,
    y1: 4.74768,
    x2: 28.9558,
    y2: 4.74768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E61AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#19569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12733_53893",
    x1: 9.34375,
    y1: 16.2583,
    x2: 38.9617,
    y2: 16.2583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E61AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#19569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12733_53893",
    x1: 38.1874,
    y1: 36.7725,
    x2: 47.9996,
    y2: 36.7725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AAD7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#109B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C9366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12733_53893",
    x1: 24.1481,
    y1: 32.0155,
    x2: 42.101,
    y2: 32.0155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AAD7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#109B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C9366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12733_53893",
    x1: -0.000103859,
    y1: 36.7722,
    x2: 9.8121,
    y2: 36.7722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12733_53893",
    x1: 5.89844,
    y1: 32.0155,
    x2: 23.8514,
    y2: 32.0155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36913"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.31007bfc127352e9e042ef9266a104c7.svg";
export { ForwardRef as ReactComponent };